import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MensagensService } from 'max-ng-lib';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { OfertaDTO } from '../core/models/oferta-dto.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthInfoService extends GenericServicesMotoristaService {

  constructor(
    private _mensagensService: MensagensService,
    private _httpClient: HttpClient
  ) {
    super();
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }
  getUrlRecurso(): string {
    return '/authInfos';
  }

  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getOfertasPorCliente(ofertas: string | string[]): Observable<OfertaDTO[]> {
    const ofertasArr = Array.isArray(ofertas) ? ofertas : [ofertas];

    return this.post('/getOfertasPorCliente', { dados: { ofertas: ofertasArr } });
  }
}
